import { useContext } from 'react';
import ContentWrapper from './ContentWrapper';
import ContentGroupType from '@/lib/constants/challengeModel/ContentGroupType.enum';
import PickerBoxArrow from './PickerBoxArrow';
import ColorOptions from './ColorOptions';
import SectionContentGroupContext from '../../../../Section/SectionContentGroupContext';

type PickerContentProps = {
  selectedColor: string | null;
  setSelectedColor: (color: string | null) => void;
};

const PickerContent = ({
  selectedColor,
  setSelectedColor,
}: PickerContentProps) => {
  const sectionContentGroup = useContext(SectionContentGroupContext);
  const inRightSectionContentGroup =
    sectionContentGroup === ContentGroupType.RIGHT;

  return (
    <ContentWrapper inRightSectionContentGroup={inRightSectionContentGroup}>
      <PickerBoxArrow inRightSectionContentGroup={inRightSectionContentGroup} />
      <ColorOptions
        selectedColor={selectedColor}
        onSelectColor={setSelectedColor}
      />
    </ContentWrapper>
  );
};

export default PickerContent;
